<mat-card style="border-color: #5775a8;">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <mat-icon style="color: white;">settings</mat-icon>
      <span style="font-size: large; color: white;">
        Process Complaint [{{currentComplaint.complaintId}}]
      </span>
    </div>
  </mat-card-header>

  <mat-card-content>
    <br />
    <mat-card>
      <mat-card-header class="flex flex-row rounded-lg w-full" style="padding: 5px;">
        <span>Determine Complaint's Actionable Status</span>
      </mat-card-header>

      <div class="flex flex-col items-center w-full">
        <br />
        <div class="flex flex-row rounded-lg w-11/12">
          <table class="w-full">
            <tr style="padding-bottom: 10px;">
              <th>Business Name</th>
              <th>Address </th>
              <th>Address 2</th>
              <th>City</th>
              <th>Zip Code</th>
            </tr>
            <tr>
              <td>{{currentComplaint.businessName}}</td>
              <td>{{currentComplaint.address}}</td>
              <td>{{currentComplaint.address2}}</td>
              <td>{{currentComplaint.city}}</td>
              <td>{{currentComplaint.zip}}</td>
            </tr>
            <tr>
              <th>Type of Business</th>
              <th>Phone </th>
              <th>Extension</th>
              <th>County</th>
              <th>Status</th>
            </tr>
            <tr>
              <td>{{typeOfBusiness(complaintView.typeOfBusiness)}}</td>
              <td>{{complaintView.businessPhone}}</td>
              <td>{{complaintView.businessPhoneExtension}}</td>
              <td>{{getCounty(complaintView.county)}}</td>
              <td>
                <span *ngIf="currentComplaint.businessActive" style="color: green;">Active</span>
                <span *ngIf="!currentComplaint.businessActive" style="color: red;">Inactive</span>
                <span *ngIf="currentComplaint.businessExempt" style="color: grey;">(Exempt)</span>
              </td>
            </tr>
            <tr>
              <th>Complaint Text</th>
              <th></th>
              <th></th>
              <th>Complaint Attachments</th>
              <th></th>
            </tr>
            <tr>
              <td colspan="3">
                  {{currentComplaint.complaintComments}}
              </td>
              <td colspan="2">
                <a *ngIf="attachmentCount > 0" (click)="getAttachment(1)">Attachment 1</a>
                <a *ngIf="attachmentCount > 1" (click)="getAttachment(2)">Attachment 2</a>
              </td>
            </tr>
          </table>

        </div>
        <br />

      </div>

    </mat-card>
    <br />

    <mat-card>

      <div class="flex flex-col w-full">
        <mat-card-header class="flex flex-row rounded-lg w-full" style="padding: 5px;background-color: #5775a8;">
          <div class="flex flex-row rounded-lg items-center w-full" style="padding-left: 20px;">
            <span style="color: white;">Actionable Status Settings</span>
          </div>
        </mat-card-header>
        <mat-card-content>

          <form [formGroup]="form">
            <div class="flex flex-col rounded-lg w-full">

              <div *ngIf="currentComplaint.businessHasActionableComplaint" class="alert alert-danger"
                style="width:550px;">
                <mat-card-header class="flex flex-col rounded-lg w-full"
                  style="padding: 5px;background-color: #e7c06c;">
                  <strong>
                    <span style="display: flex; align-items: center; justify-content: center; color: red;">
                      <mat-icon style="color: red; margin-right: 5px;">warning</mat-icon>
                      This Business has another Actionable Complaint.
                      <br />
                      An Initial Response Letter has been sent in the last 5 days.
                    </span>
                  </strong>
                </mat-card-header>
              </div>
              <br />

              <div
                *ngIf="currentComplaint.businessExempt || within5Days(currentComplaint.lastSentIrl) || currentComplaint.businessHasComplaintInPendingSiteVisit">
                <mat-card-header class="flex flex-col rounded-lg w-full "
                  style="padding: 5px;background-color: #e7c06c;">
                  <mat-list>
                    <mat-list-item *ngIf="currentComplaint.businessExempt">
                      <span style="color: red;">This Business Is Exempt.</span><br />
                      <span>
                        It is recommended to make this complaint <strong>Non-Actionable</strong> with the reason:
                        <strong>Exempt</strong>
                      </span>
                    </mat-list-item>
                    <mat-list-item *ngIf="within5Days(currentComplaint.lastSentIrl)">
                      <!-- <li *ngIf="currentComplaint.lastSentIrl != null && currentComplaint.lastSentIrl >= fiveDaysAgo"> -->
                        <span>
                        This Business has other complaints with dates within the past 5 days of this complaint
                        date.<br />
                        It is recommended to make this complaint <strong>Non-Actionable</strong> with the reason:
                        <strong>Grace Period</strong>.
                      </span>
                    </mat-list-item>
                    <mat-list-item *ngIf="currentComplaint.businessHasComplaintInPendingSiteVisit">
                      <span>
                        The system shows that this business is currently in site visit or follow-up visit status.
                        <br />Additional complaints should not be made actionable.
                        <br />It is recommended to make this complaint <strong>Non-Actionable</strong> with the reason:
                        <strong>Grace Period</strong>.
                      </span>
                    </mat-list-item>
                  </mat-list>

                  <span><br /> <a (click)="gotoBusiness(currentComplaint.businessId)" target="_blank">Click here</a> to
                    view the <a (click)="gotoBusiness(currentComplaint.businessId)" target="_blank">Business Details for
                      {{currentComplaint.businessName}}</a> or review the list of business complaints below.</span>
                </mat-card-header>
              </div>
              <br />

              <div>
                <mat-form-field class="container">
                  <mat-label>Is Complaint Actionable</mat-label>
                  <mat-select formControlName="isActionable" (selectionChange)="actionableChange($event.value)">
                    <mat-option value=false>No</mat-option>
                    <mat-option value=true>Yes</mat-option>
                  </mat-select>
                  <mat-error *ngIf="form.get('isActionable').invalid">
                    This field is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div *ngIf="!isActionable">
                <mat-form-field class="container">
                  <mat-label>Reason</mat-label>
                  <mat-select formControlName="reason">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let list of nonActionableList" [value]="list.value">
                      {{list.text}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="form.get('reason').invalid">
                    This field is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div *ngIf="isActionable">
                <div class="flex flex-col rounded-lg w-full">
                  <span>Nature of Complaint (Check all that apply:)</span>
                  <div class="flex flex-row w-full">
                    <div class="flex flex-col w-full">
                      <mat-checkbox *ngFor="let violation of violationsList" (change)="check(violation, $event)"
                        [checked]="isViolationChecked(violation)">
                        <span>{{violation.text}}</span>
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-row rounded-lg w-full">
                <div>
                  <button mat-raised-button (click)="setActionableStatus()" class="m-8"
                    style="background-color: green;">
                    <span style="color: white;">Done</span>
                  </button>
                </div>
                <div>
                  <button mat-raised-button (click)="cancel()" class="m-8">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </mat-card-content>
        <br />
      </div>
    </mat-card>
    <br />

    <mat-card>

      <mat-card-header class="flex flex-row rounded-lg w-full" style="padding: 5px;background-color: #5775a8;">
        <div class="flex flex-row rounded-lg items-center w-full" style="padding-left: 20px;">
          <span style="color: white;">Additional Complaints Associated with this Business</span>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="flex flex-col w-full">

          <div class="flex flex-col rounded-lg w-11/12">

            <div class="flex flex-col w-full" style="overflow-x:auto;">
              <div class="flex flex-row w-full">

                <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #MatSort="matSort"
                  class="w-full">


                  <ng-container matColumnDef="complaintId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
                    <td mat-cell *matCellDef="let complaint">
                      <a *ngIf="complaint.complaintId != currentComplaint.complaintId"
                        (click)="gotoComplaint(complaint.complaintId)">{{complaint.complaintId}}</a>
                      <a *ngIf="complaint.complaintId == currentComplaint.complaintId">{{complaint.complaintId}}</a>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="complaintDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Date</th>
                    <td mat-cell *matCellDef="let complaint">
                      {{complaint.complaintDate}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="complaintStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Status</th>
                    <td mat-cell *matCellDef="let complaint">{{complaint.complaintStatus}}</td>
                  </ng-container>

                  <ng-container matColumnDef="actionable">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Actionable</th>
                    <td mat-cell *matCellDef="let complaint">
                      <span *ngIf="complaint.actionable" style="color: red;">Yes</span>
                      <span *ngIf="!complaint.actionable">No</span>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

                </table>

              </div>
            </div>
          </div>

        </div>
      </mat-card-content>


    </mat-card>

    <br />
  </mat-card-content>

</mat-card>